const CONTROLLER = "/post";
const PATHS = {
	PUBLISH_POST: "",
	GET_FEED: "?limit=:limit",
	GET_POST: "/:post_id",
	UPDATE_POST: "/:post_id",
	DELETE_POST: "/:post_id",

	LIKE_POST: "/:post_id/like",
	GET_LIKES: "/:post_id/likes",
	COUNT_LIKES: "/:post_id/likes/count",
	IS_LIKED_BY_USER: "/:post_id/like/:user_id",
	REMOVE_LIKE: "/:post_id/like",
	GET_IMAGE: "/:post_id/image",
	GET_VIDEO: "/:post_id/video",
	GET_MEDIA_STATUS: "/:post_id/media-status",

	REPOST_POST: "/:post_id/repost",

	GET_COMMENTS: "/:post_id/comments",
	COUNT_COMMENTS: "/:post_id/comments/count",
	COMMENT_POST: "/:post_id/comment",
	DELETE_COMMENT: "/:post_id/comment/:comment_id",
	REPLY_TO_COMMENT: "/:post_id/comment/:parent_id/reply",
	GET_COMMENT_REPLIES: "/:post_id/comment/:parent_id/replies",
	COUNT_COMMENT_REPLIES: "/:post_id/comment/:parent_id/replies/count",

	LIKE_COMMENT: "/:post_id/comment/:comment_id/like",
	UNLIKE_COMMENT: "/:post_id/comment/:comment_id/like",
	GET_COMMENT_LIKES: "/:post_id/comment/:comment_id/likes",
	COUNT_COMMENT_LIKES: "/:post_id/comment/:comment_id/likes/count",
	IS_COMMENT_LIKED_BY_USER: "/:post_id/comment/:comment_id/like/:user_id",

	SHARE_POST: "/:postId/share",
};

export const PostApiRoutes = {
	CONTROLLER,
	PATHS,
	GET_FEED: (limit: number, cursor: string | null) =>
		`${CONTROLLER}${PATHS.GET_FEED.replace(":limit", String(limit))}${
			cursor ? `&cursor=${cursor}` : ""
		}`,
	GET_POST: (post_id: string | undefined) =>
		`${CONTROLLER}${PATHS.GET_POST.replace(":post_id", String(post_id))}`,
	UPDATE_POST: (post_id: string | undefined) =>
		`${CONTROLLER}${PATHS.UPDATE_POST.replace(":post_id", String(post_id))}`,
	DELETE_POST: (post_id: string | undefined) =>
		`${CONTROLLER}${PATHS.DELETE_POST.replace(":post_id", String(post_id))}`,

	LIKE_POST: (post_id: string | undefined) =>
		`${CONTROLLER}${PATHS.LIKE_POST.replace(":post_id", String(post_id))}`,
	GET_LIKES: (post_id: string | undefined) =>
		`${CONTROLLER}${PATHS.GET_LIKES.replace(":post_id", String(post_id))}`,
	IS_LIKED_BY_USER: (
		post_id: string | undefined,
		user_id: string | undefined
	) =>
		`${CONTROLLER}${PATHS.IS_LIKED_BY_USER.replace(
			":post_id",
			String(post_id)
		).replace(":user_id", String(user_id))}`,
	REMOVE_LIKE: (post_id: string | undefined) =>
		`${CONTROLLER}${PATHS.REMOVE_LIKE.replace(":post_id", String(post_id))}`,
	GET_IMAGE: (post_id: string | undefined) =>
		`${CONTROLLER}${PATHS.GET_IMAGE.replace(":post_id", String(post_id))}`,
	GET_VIDEO: (post_id: string | undefined) =>
		`${CONTROLLER}${PATHS.GET_VIDEO.replace(":post_id", String(post_id))}`,
	GET_MEDIA_STATUS: (post_id: string | undefined) =>
		`${CONTROLLER}${PATHS.GET_MEDIA_STATUS.replace(":post_id", String(post_id))}`,

	REPOST_POST: (post_id: string | undefined) =>
		`${CONTROLLER}${PATHS.REPOST_POST.replace(":post_id", String(post_id))}`,

	GET_COMMENTS: (post_id: string | undefined) =>
		`${CONTROLLER}${PATHS.GET_COMMENTS.replace(":post_id", String(post_id))}`,
	COMMENT_POST: (post_id: string | undefined) =>
		`${CONTROLLER}${PATHS.COMMENT_POST.replace(":post_id", String(post_id))}`,
	DELETE_COMMENT: (
		post_id: string | undefined,
		comment_id: string | undefined
	) =>
		`${CONTROLLER}${PATHS.DELETE_COMMENT.replace(
			":post_id",
			String(post_id)
		).replace(":comment_id", String(comment_id))}`,

	REPLY_TO_COMMENT: (
		post_id: string | undefined,
		parent_id: string | undefined
	) =>
		`${CONTROLLER}${PATHS.REPLY_TO_COMMENT.replace(
			":post_id",
			String(post_id)
		).replace(":parent_id", String(parent_id))}`,
	GET_COMMENT_REPLIES: (
		post_id: string | undefined,
		parent_id: string | undefined
	) =>
		`${CONTROLLER}${PATHS.GET_COMMENT_REPLIES.replace(
			":post_id",
			String(post_id)
		).replace(":parent_id", String(parent_id))}`,
	COUNT_COMMENT_REPLIES: (
		post_id: string | undefined,
		parent_id: string | undefined
	) =>
		`${CONTROLLER}${PATHS.COUNT_COMMENT_REPLIES.replace(
			":post_id",
			String(post_id)
		).replace(":parent_id", String(parent_id))}`,

	LIKE_COMMENT: (post_id: string | undefined, comment_id: string | undefined) =>
		`${CONTROLLER}${PATHS.LIKE_COMMENT.replace(
			":post_id",
			String(post_id)
		).replace(":comment_id", String(comment_id))}`,
	UNLIKE_COMMENT: (
		post_id: string | undefined,
		comment_id: string | undefined
	) =>
		`${CONTROLLER}${PATHS.LIKE_COMMENT.replace(
			":post_id",
			String(post_id)
		).replace(":comment_id", String(comment_id))}`,
	GET_COMMENT_LIKES: (
		post_id: string | undefined,
		comment_id: string | undefined
	) =>
		`${CONTROLLER}${PATHS.GET_COMMENT_LIKES.replace(
			":post_id",
			String(post_id)
		).replace(":comment_id", String(comment_id))}`,
	COUNT_COMMENT_LIKES: (
		post_id: string | undefined,
		comment_id: string | undefined
	) =>
		`${CONTROLLER}${PATHS.COUNT_COMMENT_LIKES.replace(
			":post_id",
			String(post_id)
		).replace(":comment_id", String(comment_id))}`,

	SHARE_POST: (postId: string | undefined) =>
		`${CONTROLLER}${PATHS.SHARE_POST.replace(":postId", String(postId))}`,
};
